import { I18n } from '@calendly/i18n';
import { Badge } from '@calendly/ui/components/badge';
import { Button } from '@calendly/ui/components/button';
import { Grid, GridItem } from '@calendly/ui/components/grid';
import { BodyText, HeadlineText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { TitleContainer, Container } from './elements';
const styledContainerCss = "s1tet71l";
const StyledContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(styledContainerCss, props.className)} />;
});
const styledGridCss = "s485r39";
const StyledGrid = forwardRef((props, ref) => <Grid ref={ref} {...props} className={classNames(styledGridCss, props.className)} />);
const styledGridItemCss = "s1yn0ft1";
const StyledGridItem = forwardRef((props, ref) => <GridItem ref={ref} {...props} className={classNames(styledGridItemCss, props.className)} />);
const rowItemCss = "rm43pxp";
const RowItem = forwardRef((props, ref) => <GridItem ref={ref} {...props} className={classNames(rowItemCss, props.className)} />);
const OrganizationRow = ({
  organization,
  onConfirm
}) => <RowItem size={12} as="li">
    <Grid>
      <GridItem size={7}>
        <BodyText>{I18n.t('publisher.organization.join.modal.organization_row.name', {
          name: organization.name
        })}</BodyText>
        <BodyText color="muted">
          {I18n.t('publisher.organization.join.modal.organization_row.count', {
          count: organization.organizationMembershipsCount
        })}
        </BodyText>
      </GridItem>
      <StyledGridItem size={5}>
        {organization.organizationInvitation?.status === 'organization_declined' ? <Badge>{I18n.t('publisher.organization.join.modal.organization_row.request_declined')}</Badge> : <Button onClick={() => onConfirm(organization)} size="small" decoration="secondary-outline" aria-label={I18n.t('publisher.organization.join.modal.organization_row.button_label', {
        name: organization.name
      })}>
                  {I18n.t('publisher.organization.join.modal.organization_row.button')}
                </Button>}
      </StyledGridItem>
    </Grid>
  </RowItem>;
export const RequestToJoinOrgs = ({
  onConfirm,
  joinableOrganizations
}) => <Container>
    <TitleContainer>
      <Grid>
        <GridItem>
          <HeadlineText level={1} size="small">
            {I18n.t('publisher.organization.join.modal.initial_title')}
          </HeadlineText>
        </GridItem>
      </Grid>
    </TitleContainer>
    <BodyText>{I18n.t('publisher.organization.join.modal.description')}</BodyText>
    <StyledContainer>
      <BodyText weight="bold">
        {I18n.t('publisher.organization.join.modal.pick_a_team_to_connect_with')}
      </BodyText>
      <StyledGrid>
        <GridItem size={12}>
          <Grid spacing={16} as="ul">
            {joinableOrganizations.map(org => <OrganizationRow key={org.id} organization={org} onConfirm={onConfirm} />)}
          </Grid>
        </GridItem>
      </StyledGrid>
    </StyledContainer>
  </Container>;

require("./request-to-join-orgs.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./request-to-join-orgs.js");